import { useState } from 'react';

const usePagination = ({ initialLimit = 10, initialOffset = 0, initialPage = 0 }) => {
  const [limit, setLimit] = useState(initialLimit);
  const [offset, setOffset] = useState(initialOffset);
  const [currentPage, setCurrentPage] = useState(initialPage);

  // sets limit and resets offset and current page
  const onClickLimit = (value) => {
    setLimit(value);
    setOffset(0);
    setCurrentPage(0);
  };
  // sets offset and current page
  const onClickPage = (data) => {
    // data comes from ReactPaginate
    const { selected } = data;
    const newOffset = Math.ceil(selected * limit);
    setOffset(newOffset);
    setCurrentPage(selected);
  };
  const resetPagination = () => {
    setOffset(initialOffset);
    setCurrentPage(initialPage);
  };

  return {
    limit,
    offset,
    currentPage,
    onClickLimit,
    onClickPage,
    resetPagination,
  };
};

export default usePagination;
